export namespace PrintOrderConstants {
  export const DEFAULT_CASETYPE_VALUE = 'plastic-cover';
  export const DEFAULT_PRINT_SIZE = 'A4';
  export const DEFAULT_PRINT_COLOR_TYPE = 'bw';
  export const MIXED = 'mixed';
}

export enum PrintColorsConstant {
  MIXED = 'mixed',
  COLORFUL = 'c',
  HALF_COLORFUL = 'hc',
  BLACK_WHITE = 'bw',
}
export enum OrderTypeConstant {
  PRINT = 'print',
  THESIS = 'thesis',
  THESIS_EDIT = 'thesis-edit',
}

export const PrintBlockStockNameTypeRegex = {
  colorful: /([1|2]c)(?![a-z]|[0-9])/gm,
  halfColorful: /([1|2]hc)(?![a-z]|[0-9])/gm,
  blackAndWhite: /([1|2]bw)(?![a-z]|[0-9])/gm,
};

export const orderStatusesArray = [
  'progress',
  'done',
  'calculation',
  'failed',
  'payment',
  'delivered',
  'sent',
] as const;

export enum PrintSizes {
  A4 = 'A4',
  A5 = 'A5',
  A3 = 'A3',
}
